// 현장관리(iggg-sites)의 추가공사(extra_works)를 간이견적 후보로 읽어온다.
// 별도 Firebase 프로젝트라 REST(fetch만, firebase SDK 불필요) + 실직원 신원 토큰
// (sitesToken — 보안 웨이브 3, 익명 폴백).
// 잔금내역서↔계약서 연동과 같은 '공유 Firestore 읽기' 패턴.
import { sitesToken as token } from "./lib/sitesToken";

const P = import.meta.env.VITE_SITES_PROJECT_ID || "iggg-sites";

const S = (v) => v?.stringValue || "";
const N = (v) => Number(v?.integerValue || v?.doubleValue || 0);
const B = (v) => v?.booleanValue === true;

// 추가공사 후보 (현장별 항목 평탄화) [{ siteName, date, desc, amount, tbd, confirmed }]
export async function fetchExtraWorkCandidates() {
  const t = await token();
  if (!t) return [];
  try {
    // ⚠pageToken 순회 — 종전엔 pageSize=300 **1회 호출**이라 301번째부터 조용히
    //   잘렸다(감사 2026-07-29 #95). 추가공사는 `현장×일자` 단위라 이 저장소에서
    //   가장 먼저 300을 넘긴다. 같은 저장소의 hubExec/scheduleDb 가 쓰는 방식과 동일.
    const url = `https://firestore.googleapis.com/v1/projects/${P}/databases/(default)/documents/extra_works`;
    const headers = { Authorization: "Bearer " + t };
    const docs = [];
    let pageToken = "";
    do {
      const r = await fetch(
        `${url}?pageSize=300${pageToken ? `&pageToken=${encodeURIComponent(pageToken)}` : ""}`,
        { headers });
      if (!r.ok) break;
      const j = await r.json();
      docs.push(...(j.documents || []));
      pageToken = j.nextPageToken || "";
    } while (pageToken);
    const out = [];
    docs.forEach((d) => {
      const f = d.fields || {};
      const siteName = S(f.siteName), date = S(f.date);
      ((f.items?.arrayValue?.values) || []).forEach((v) => {
        const mf = v.mapValue?.fields || {};
        const desc = S(mf.desc);
        if (!desc) return;
        out.push({ siteName, date, desc, amount: N(mf.amount), tbd: B(mf.tbd), confirmed: B(mf.confirmed) });
      });
    });
    // 최신 날짜순
    return out.sort((a, b) => (b.date || "").localeCompare(a.date || ""));
  } catch {
    return [];
  }
}
